import { Link } from 'react-router-dom';
import { ROUTES } from '@/routes/routes';
import './stockHistoryLink.css';

export interface StockHistoryLinkProps {
  /** The line's sku as the API gives it; null, blank and padded values are handled here. */
  sku: string | null | undefined;
  /** Runs on the click, so a scan desk can hand the cursor back to its scan box. */
  onOpen?: () => void;
}

/**
 * A sku that opens its own Stock History: stock, shelves and every movement [SSD-7444]. It opens in a new tab,
 * so the screen it sits on keeps its order and its scan box, and a scanner's Enter never reopens it.
 */
export function StockHistoryLink({ sku, onOpen }: StockHistoryLinkProps) {
  // A padded sku would open a failed search and a blank one has no history, so the link reads the trimmed
  // value and a blank sku renders nothing (SSD-7781).
  const key = (sku ?? '').trim();
  if (!key) {
    return null;
  }
  return (
    <Link
      className="stock-history-link"
      to={ROUTES.fulfillment.stockHistorySku(key)}
      target="_blank"
      rel="noopener noreferrer"
      title={`Open the Stock History of ${key}`}
      onClick={onOpen}
    >
      {key}
    </Link>
  );
}
